import type { ApolloError } from '@apollo/client';
import { $ } from '../lib/generated/zeus';
import { useTypedMutation } from '../lib/generated/zeus/apollo';

const affectedRows = { affected_rows: true };

const useModifyShift = (onError: (e: ApolloError) => void) =>
  useTypedMutation(
    {
      // Hasura queries are executed sequentially.
      // https://hasura.io/docs/latest/queries/postgres/multiple-queries/
      // Since we may be deleting a shift and creating a new shift in its place,
      // we want to perform the delete first for chronological event lookup.
      insert_event_shift_deleted: [
        {
          objects: $('shiftsToDelete', '[event_shift_deleted_insert_input]!'),
        },
        affectedRows,
      ],
      insert_event_derived_shift_updated: [
        {
          objects: $(
            'shiftExceptionUpdates',
            '[event_derived_shift_updated_insert_input]!'
          ),
        },
        affectedRows,
      ],
      insert_event_derived_shift_deleted: [
        {
          objects: $(
            'shiftExceptionDeletes',
            '[event_derived_shift_deleted_insert_input]!'
          ),
        },
        affectedRows,
      ],
      insert_event_shift_created: [
        {
          objects: $('shiftsToCreate', '[event_shift_created_insert_input]!'),
        },
        affectedRows,
      ],
      insert_event_shift_updated: [
        {
          objects: $('shiftsToUpdate', '[event_shift_updated_insert_input]!'),
        },
        affectedRows,
      ],
      insert_event_note_created: [
        {
          objects: $('notesToCreate', '[event_note_created_insert_input]!'),
        },
        affectedRows,
      ],
    },
    { apolloOptions: { onError } }
  );

export default useModifyShift;
